import { useEffect, useState } from 'react';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Input from '../../../../components/Inputs/Input';
import Item from '../../../../components/Lists/Item';
import './OverrideItem.css';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { HTTP_RESPONSE_CODES, LABELS } from '../../../../globals/globals';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import { ThreshInterval } from './ThreshInterval';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import { useDispatch, useSelector } from 'react-redux';
import { deleteOverride, discardOvrChanges, fetchSpecificOverride, ovrChange, saveOverrideCall, selectEditingOvr, selectIdxOverride, selectOvrBackup, selectOvrForm, toggleOvrEdition } from '../../../../redux/features/configuration/parts/TimeControlsSlice';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import DeletePartDialog from './DeletePartDialog';

const dropdownNameMap = {
    aircraftTypes: "Type/Series",
    aircrafts: "AC",
    nha: "NHA PN"
}

const threshFormNames = {
    threshHours: "thresholdHours",
    threshCycles: "thresholdCycles",
    threshDays: "thresholdDays",
    totalHours: "thresholdTotalHours",
    totalCycles: "thresholdTotalCycles",
    totalDays: "thresholdTotalDays",
    threshSchedule: "thresholdScheduleDate",
    threshLatest: "thresholdLatest",
    intervalHours: "intervalHours",
    intervalCycles: "intervalCycles",
    intervalDays: "intervalDays",
    intervalSchedule: "intervalScheduleDate",
    intervalLatest: "intervalLatest",
}


export const OverrideItem = ({ part, override, controlId }) => {


    // const [editing, setEditing] = useState(false);
    const editing = useSelector((state) => selectEditingOvr(state, override.id));
    const { infoMsg, successMsg, warningMsg } = useSnackBar();
    const dispatch = useDispatch();
    const ovrInfo = useSelector((state) => selectIdxOverride(state, override.id));
    const form = useSelector((state) => selectOvrForm(state, override.id));


    const saveClick = (closeEdition) => {
        infoMsg("Saving override");

        //TODO: change to overrride;
        dispatch(saveOverrideCall({ ovrId: override.id, controlId, closeEdition })).then(action => {
            let { response } = action.payload;
            if (response.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
                successMsg("Override saved");
            } else {
                warningMsg(response.message, response.validationErrors?.map(e => e.error).join(", "));
            }
        }
        );
    }

    const deleteOvr = () => {
        infoMsg("Removing override");
        dispatch(deleteOverride({ ovrId: override.id, controlId })).then(action => {
            if (action.payload) {
                successMsg("Override successfully removed");
            }
        }
        )
    }

    const startEdition = () => {
        dispatch(toggleOvrEdition({ ovrId: override.id, toValue: true }));
    }

    const cancelEdition = () => {
        //TODO: discard local changes || discard override with version 0;
        // dispatch(discardOvrChanges({ovrId: override.id}));
        if (form.version === 0) {
            dispatch(deleteOverride({ ovrId: override.id, controlId }));
            infoMsg("Override discarded")
        }
        dispatch(discardOvrChanges({ ovrId: override.id }));
        // dispatch(toggleOvrEdition({ ovrId: override.id, toValue: false }));
    }

    const [openStatus, setOpenStatus] = useState(false);

    const discardOvr = () => {
        dispatch(deleteOverride({ ovrId: override.id, controlId }));
        infoMsg("Override discarded")
    }

    return (
        <div className='override-item-component'>
            <Expandable2
                onOpenChange={(e) => setOpenStatus(e)}
                summary={
                    <Item
                        itemPrefix={() =>
                            <div className='selected-type'>
                                {
                                    <div className='type-items'>
                                        <b>Type/Series</b>
                                        <div className='type-item'>
                                            <span>{ovrInfo?.typeSerie || "--"}</span>
                                        </div>
                                        <div className='type-item'>
                                            <b>AC</b>
                                            <span>{ovrInfo?.tailNumber || "--"}</span>
                                        </div>
                                        <div className='type-item'>
                                            <b>Position</b>
                                            <span>{ovrInfo?.position || "--"}</span>
                                        </div>
                                        <div className='type-item'>
                                            <b>NLA Position</b>
                                            <span>{ovrInfo?.nlaPosition || "--"}</span>
                                        </div>
                                        <div className='type-item'>
                                            <b>NHA</b>
                                            <span>{ovrInfo?.nhaPartNumber || "--"}</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        ribbon={[{ when: editing, label: LABELS.EDITION_MODE }]}
                        item={{}}

                    >
                        <div className='override-suffix'>
                            {/* <div className='schedule'>
                                    <span>Schedule</span>
                                    <b>--</b>
                                </div> */}
                            <div className='override-actions' onClick={(e) => e.stopPropagation()}>
                                {!editing &&
                                    (openStatus ? <button className='transparent'>
                                        <i className='icon-edit actionbutton' onClick={(e) => { startEdition() }}></i>
                                    </button> : <i className='icon-edit actionbutton' onClick={(e) => { startEdition() }}></i>)
                                }
                                {editing && <MultioptionButton buttons={[
                                    { label: 'Save and Finish', onClick: () => { saveClick(true) }, icon: "icon-save", id: 'save' },
                                    { label: 'Save and Continue Editing', onClick: () => { saveClick(false) }, icon: "icon-save", id: 'save-continue' },
                                    { label: 'Cancel', onClick: () => { cancelEdition() }, icon: "icon-cross", id: 'cancel', type: 'danger' }
                                ]}></MultioptionButton>}
                                {form?.version === 0 ? <i onClick={() => discardOvr()} className='icon-delete-new actionbutton'></i> : <DialogTrigger dialogContent={{
                                    component: DeletePartDialog, props: {
                                        item: { 
                                            "Type/Series": ovrInfo?.typeSerie || "--",
                                            "AC": ovrInfo?.tailNumber || "--",
                                            "Position": ovrInfo?.position || "--",
                                            "NLA Position": ovrInfo?.nlaPosition || "--",
                                            "NHA" : ovrInfo?.nhaPartNumber || "--"
                                        },
                                        message: "Are you sure you want to delete this override?",
                                        onDelete: deleteOvr
                                    }
                                }}>
                                    <i className='icon-delete-new actionbutton'></i>
                                </DialogTrigger>}
                            </div>
                        </div>

                    </Item>
                }>
                <OverrideContent part={part} override={override} editing={editing} timeControlId={controlId} />

            </Expandable2>

        </div>
    )
}

const OverrideContent = ({ open, part, override, editing, timeControlId }) => {
    const dispatch = useDispatch();
    const configType = useDropdownConfig(56);
    const configAC = useDropdownConfig(51);
    const configPosition = useDropdownConfig(52);
    const configNHA = useDropdownConfig(53);
    const configNLA = useDropdownConfig(54);


    const [companyParameter, _] = useState({ "columnName": "accountId", value: parseInt(localStorage.getItem('u_account_id')) });

    const [typeParams, setTypeParams] = useState([companyParameter]);
    const [ACParams, setACParams] = useState([companyParameter, {"columnName": "seriesId", value: null}]);
    const [NHAParams, setNHAParams] = useState([companyParameter, { "columnName": "partId", value: part.id }]);
    const [nlaParams, setNlaParams] = useState([{ "columnName": "partId", value: part.id }]);

    const form = useSelector((state) => selectOvrForm(state, override.id));
    const backupForm = useSelector((state) => selectOvrBackup(state, override.id));

    useEffect(() => {
        dispatch(fetchSpecificOverride({ ovrId: override.id }));
    }, [open])

    const [threshForm, setThreshForm] = useState({
        threshHours: "",
        threshCycles: "",
        threshDays: "",
        totalHours: "",
        totalCycles: "",
        totalDays: "",
        threshSchedule: "",
        threshLatest: false,
        intervalHours: "",
        intervalCycles: "",
        intervalDays: "",
        intervalSchedule: "",
        intervalLatest: false,
    })

    useEffect(() => {
        if (form) {
            setThreshForm({
                threshHours: form.thresholdHours,
                threshCycles: form.thresholdCycles,
                threshDays: form.thresholdDays,
                totalHours: form.thresholdTotalHours,
                totalCycles: form.thresholdTotalCycles,
                totalDays: form.thresholdTotalDays,
                threshSchedule: form.thresholdScheduleDate,
                threshLatest: form.thresholdLatest,
                intervalHours: form.intervalHours,
                intervalCycles: form.intervalCycles,
                intervalDays: form.intervalDays,
                intervalSchedule: form.intervalScheduleDate,
                intervalLatest: form.intervalLatest,
            })
        }
    }, [form]);

    const updateThreshForm = (e) => {
        const { name, value } = e;
        setThreshForm(prev => ({
            ...prev,
            [name]: value
        }));
        dispatch(ovrChange({ name: threshFormNames[name], value, ovrId: override.id }));
    }

    const ovrInfoChange = (e) => {
        let { name } = e;
        dispatch(ovrChange({ ...e, ovrId: override.id }));
        if (name==="accountFleetId") {
            setACParams(prev => ([companyParameter, {"columnName": "seriesId", value: e.value}]));

        }
    }

    return (
        <div className="override-content">
            <div className='inputs-container'>
                <b>Repeat Number</b>
                <Input onChange={(e) => ovrInfoChange({ name: 'maxRepetitions', value: e.target.value })} className="qty" isNumeric disabled={!editing} value={form?.maxRepetitions} />
                <CheckboxField onChange={(e) => ovrInfoChange({ name: 'useFlightDays', value: e })} checked={form?.useFlightDays} disabled={!editing}>Use Flight Days</CheckboxField>
                {/* <Input label="inputs 1" disabled={!editing} /> */}
                {/* <Input label="inputs 1" disabled={!editing} /> */}
                {/* <Input label="inputs 1" disabled={!editing} /> */}
                <Dropdowns onOptionSelect={(newOption) => ovrInfoChange({ name: 'accountFleetId', value: newOption["c.id"], completeValue: newOption })} preSelectValue={backupForm?.accountFleetId} selectionLabel="name" optionLabel="name" parameters={typeParams} data={configType.config} disabled={!editing} />
                <Dropdowns onOptionSelect={(newOption) => ovrInfoChange({ name: 'aircraftId', value: newOption.id, completeValue: newOption })} preSelectValue={backupForm?.aircraftId} parameters={ACParams} data={configAC.config} disabled={!editing} />
                <Input onChange={(e) => ovrInfoChange({ name: 'position', value: e.target.value })} value={form?.position} disabled={!editing} label="Position" />
                {/* <Dropdowns data={configPosition.config} disabled={!editing} /> */}
                {/* <p>{JSON.stringify(part)}</p> */}
                {typeof (part?.parentPartId) === 'number' && <Dropdowns onOptionSelect={(newOption) => ovrInfoChange({ name: 'nhaId', value: newOption.id, completeValue: newOption })} preSelectValue={backupForm?.nhaId} parameters={NHAParams} data={configNHA.config} disabled={!editing} />}
                <Dropdowns onOptionSelect={(newOption) => ovrInfoChange({ name: 'nlaPositionId', value: newOption.id, completeValue: newOption })} preSelectValue={backupForm?.nlaPositionId} parameters={nlaParams} data={configNLA.config} disabled={!editing} />

            </div>
            <ThreshInterval
                values={threshForm}
                onChange={updateThreshForm}
                disabled={!editing} />
        </div>
    );
}